import { InputNumber } from "primereact/inputnumber";

// Icons
import { TbPigMoney } from "react-icons/tb";

// Types
import type { ICSTProps } from "./types";

export function CST({setTimeToBuildSell,timeToBuildSell}: ICSTProps) {

    return (<span style={{
            maxWidth: 'calc(50% - 0.75rem)',
            minWidth: 'calc(50% - 0.75rem)',
        }} className="max-sm:!w-full max-sm:!min-w-full max-sm:!max-w-ful md:flex-1 h-auto flex flex-col justify-between gap-3
                rounded-xl
                border-slate-200 border-[1px]
                bg-white shadow-md overflow-hidden
            "
        >
            <span className="w-full flex flex-row items-center gap-2 px-4 pt-4 pb-2 border-slate-200 border-b-[1px]">
                <TbPigMoney size={25} />
                <span className="font-semibold">Tempo de obra e venda</span>
            </span>

            <span className="w-full h-auto flex flex-col gap-3 p-4">
                <span className="w-full h-auto flex flex-col md:flex-row items-center justify-between gap-4">
                    <span>Tempo de obra e venda (Em meses)</span>
                    <InputNumber
                        mode="decimal"
                        locale="pt-BR"
                        minFractionDigits={0}
                        maxFractionDigits={0}
                        value={timeToBuildSell}
                        onValueChange={(e) => setTimeToBuildSell(e.value || 0)}
                    />
                </span>
            </span>
        </span>
    )
}
